import React from "react";
import ProfilePerUser from "./ProfilePerUser";

const Profile = () => {
  
  
  return (
    <>
      <div className="">
        <ProfilePerUser />
      </div>
    </>
  );
};

export default Profile;
